import React, { Component } from 'react';
import * as Common from '../helpers/Common';
import Pagination from '../helpers/Pagination';
import * as Config from '../config/Config';
import * as User from '../helpers/User';
const $= window.$;
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';

class LoginHistory extends Component {
	constructor(props) {
		super(props);

        this.state={
            learnerHistorytime : [],
            startDate: '',
            endDate : '',
												pageOfItems:[],
												total_co : 0,

        };
        this.onSubmit=this.onSubmit.bind(this);
	}

	   handleDateChange(e) {
	   	if(e.target.name=="datestart"){


	    	this.setState({startDate: $("#datestart").datepicker().val()});
	   	}

	   	if(e.target.name=="dateend"){

	    	this.setState({endDate: $("#dateend").datepicker().val()});
	   	}
	  }

	onSubmit(e){


		this.getLearnerLoginHistory();

		e.preventDefault();

	}

	componentWillReceiveProps(next) {
    
	this.getLearnerLoginHistory();
	}


    getLearnerLoginHistory(){
					   Common.reactLoader("show", "Please wait...");
    	let learnerID = Common.getUserData("id", true);
    	fetch(Config.domainUrl+'learning/login-history', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
									'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    learner_id:learnerID, start_date : this.state.startDate , end_date : this.state.endDate
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
																Common.reactLoader("hide");
				if(responseJson.status != 0){
					
	                this.setState({
																					pageOfItems:[],
	                    learnerHistorytime: responseJson.learnerHistorytime,
	                    total_co : responseJson.total_count,

	                });
				}

															Common.downTabClose();


   		 });

    }

				onChangePage(pageOfItems) {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }


    componentDidMount() {

        this.getLearnerLoginHistory();

        $("#datestart").datepicker({
			dateFormat: 'yy-mm-dd' ,
			changeMonth: true,
			yearRange: "-10:+0",
			changeYear: true,
			onSelect:function(selected,evnt){

				this.setState({
					startDate: selected
				});
			}.bind(this)

		});

		$("#dateend").datepicker({
			dateFormat: 'yy-mm-dd' ,
			changeMonth: true,
			yearRange: "-10:+0",
			changeYear: true,
			onSelect:function(selected,evnt){
				this.setState({
					endDate: selected
				});
			}.bind(this)
		});


				//Common.showSmallLeftMenu();

    }






		render() {


			//alert(JSON.stringify(this.state.learnerHistorytime));<Left onClick={this.showComponetDetails} />
			let learnerHistorytime = this.state.pageOfItems.map((learnerHistorytime,index) => {
				
		        return(
		         	<tr key={`learnerHistorytime_${index}`} >
		         	<td className="evenbg">{learnerHistorytime.date}</td>
		         	<td  className="evenbg">{learnerHistorytime.count}</td>
		         	<td  className="evenbg"><span dangerouslySetInnerHTML={{__html: learnerHistorytime.login_timing}}/></td>
		         	</tr>
		      )
				 });				 

			(learnerHistorytime.length == 0) ? learnerHistorytime = <tr align="center"><td colSpan="3">No Histories found.</td></tr> : learnerHistorytime = learnerHistorytime

			let radio = Common.getUserData('radio', true);		 
			return (

			<section id="contentsection" className="contentarea">
				<div className="inner-title-bg journey-tit-bg">
					<h1><span><img src={process.env.PUBLIC_URL+"/images/login_history_img.png"} alt="" border="0" align="absmiddle" /></span>Login History<br /><span className="subtitle">Date and time of past logins.</span></h1>
				</div>
				<div className="myperformance opinion-polls login-history">
				  <section id="semana-scroll-inner" className="scroll">
				    <section className="viewport">
				      <section className="overview">
				        <div className="inner-content">
								{(radio != false)? 
									<h1><span className="his-li">No. of hours spent till date:</span> 6 <span className="his-li">hrs</span> 10 <span className="his-li">min</span> <span className="his-rgt">  <span className="his-li">Average No. of hours spent by all:</span> 22 <span className="his-li">hrs</span> 10 <span className="his-li">min</span> </span></h1>
									 :
				     		<h1>My total visits till date - {this.state.total_co}</h1>}
						      <div className="login-history-outer">
						      	<form name="loginhistory_form" onSubmit={this.onSubmit}  action="" method="post">
						        <div className="login-history-head">

						          <ul>

								        <li><label>From Date</label>
		            					<input type="text"  value={this.state.startDate} name="datestart" id="datestart" className="txtdate" /></li>
		        	  					<li><label>To Date</label>
		            					<input type="text"  value={this.state.endtDate} name="dateend" id="dateend" className="txtdate" /></li>

						            <li><input type="submit" value="Search" name="" title="Search" /></li>
						          </ul>
						        </div>
						      </form>

									{(radio != false)? 
									<div className="mockupdemo">
										<div className="tblResponsive">
											<table>
												<tbody>
													<tr>
														<th width="15%">Login Data</th>
														<th width="15%">No. of Logins</th>
														<th width="70%">Time of Login(IST)</th>
													</tr>
													<tr>
														<td>05-Dec-2018</td>
														<td>2</td>
														<td>
															<ul>
																<li>12.50 PM</li>
																<li>09.45 PM</li>
															</ul>
														</td>
													</tr>
													<tr>
														<td>04-Dec-2018</td>
														<td>2</td>
														<td>
															<ul>
																<li>10.20 AM</li>
																<li>10.09 PM</li>
																<li>1.09 PM</li>
															</ul>
														</td>
													</tr>
													<tr>
														<td>03-Dec-2018</td>
														<td>3</td>
														<td>
															<ul>
																<li>12.12 PM</li>
															</ul>
														</td>
													</tr>

												</tbody>
											</table>
										</div>
									</div>

:
						   			<div className="login-table table-cont-login">
							   			<table  border="0" width="100%" cellPadding="0" cellSpacing="0" className="myjourney-table">
								            <thead>
								              <tr>
								                <th>Login Date</th>
								                <th>No. of logins</th>
								                <th >Time of login ( IST )</th>
								              </tr>
								            </thead>
								            <tbody>

												{learnerHistorytime}

								            </tbody>
							           </table>
																		<div className="pull-right">
																		<Pagination items={this.state.learnerHistorytime} onChangePage={e=>this.onChangePage(e)} />
																		</div>
						          	</div>
									}
								 </div>
						    </div>

				      </section>
				    </section>
				  </section>
				</div>
			</section>

			);
		}
}

export default LoginHistory;



// WEBPACK FOOTER //
// ./src/learning_records/LoginHistory.js